import React, { useState } from 'react';

import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import Style from './MobileSidebar.module.css';

import { signOut } from '../../../redux/actions/auth';

import { pushEventInLoggy } from '../../../utils/loggy';

function MobileSidebar({ open, closeModal, toggleModal }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const path = router?.pathname;
  const params = router?.query;
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const currentUser = useSelector((state) => state.currentUser);
  const { my_profile } = useSelector((state) => state);

  const handleLogout = () => {
    dispatch(signOut())
      .then(() => {
        router.push('/');
      })
      .catch(() => {});
  };

  const handleEventTrigger = (event_name) => {
    pushEventInLoggy(
      {
        event: event_name,
        page_name: 'Candidate Dashboard'
      },
      my_profile
    );
  };

  return (
    <Modal className='sidebarModal' isOpen={open} onHide={closeModal} toggle={toggleModal}>
      <ModalBody>
        <div className={Style.SidebarContainer}>
          <div className={Style.ExpertLogoOuter}>
            <a href='/'>
              <img className={Style.ExpertLogo} src='/images/login/logo.svg' />
            </a>
          </div>
          <div className={path?.includes('jobs') ? `${Style.normalBtn}` : `${Style.normalBtn} `} onClick={() => setOpen1(!open1)}>
            <img src='/images/header-images/briefcase.svg' />
            <div className='relative-position'>
              <div className='y-center-Pos'>Jobs</div>
            </div>
            <div className='align-right full-width p-r-l-50'>
              <img src={open1 ? '/images/header-images/arrow-down.svg' : '/images/header-images/arrow-up.svg'} />
            </div>
          </div>
          {open1 ? (
            currentUser?.data ? (
              <ul className='no-list-bullets padding0L m-b-0'>
                <li>
                  <a href='/jobs/explore'>
                    <div className={path === '/jobs/explore' ? `${Style.normalSubBtn} ${Style.selectedBig} ` : `${Style.normalSubBtn}`}>Explore Jobs</div>
                  </a>
                </li>
                <li>
                  <a href='/jobs/applied-jobs' onClick={() => handleEventTrigger('Applied_Jobs')}>
                    <div className={path === '/jobs/applied-jobs' ? `${Style.normalSubBtn}  ${Style.selectedBig}` : `${Style.normalSubBtn}`}>Applied Jobs</div>
                  </a>
                </li>
                <li>
                  <a href='/jobs/saved-jobs' onClick={() => handleEventTrigger('Saved_Jobs')}>
                    <div className={path === '/jobs/saved-jobs' ? `${Style.normalSubBtn}  ${Style.selectedBig}` : `${Style.normalSubBtn}`}>Saved Jobs</div>
                  </a>
                </li>
              </ul>
            ) : (
              <ul className='no-list-bullets padding0L'>
                <li>
                  <a href='/jobs/explore'>
                    <div className={path === '/jobs/explore' ? `${Style.normalSubBtn} ${Style.selectedBig} ` : `${Style.normalSubBtn}`}>Explore Jobs</div>
                  </a>
                </li>
              </ul>
            )
          ) : null}
          {currentUser?.data ? (
            <>
              <div className={`${Style.normalBtn} `} onClick={() => setOpen2(!open2)}>
                <img src='/images/header-images/activity.svg' />
                <div className='relative-position'>
                  <div className='y-center-Pos'>My Engagements</div>
                </div>
                <div className='align-right full-width p-r-l-50'>
                  <img src={open2 ? '/images/header-images/arrow-down.svg' : '/images/header-images/arrow-up.svg'} />
                </div>
              </div>
              {open2 ? (
                <ul className='no-list-bullets padding0L'>
                  <li>
                    <a href='/engagements?tab=active&section=overview'>
                      <div className={params?.tab === 'active' ? `${Style.normalSubBtn} ${Style.selectedBig}` : `${Style.normalSubBtn}`}>Active</div>
                    </a>
                  </li>
                  <li>
                    <a href='/engagements?tab=closed' onClick={() => handleEventTrigger('Applied_Jobs')}>
                      <div className={params?.tab === 'closed' ? `${Style.normalSubBtn} ${Style.selectedBig}` : `${Style.normalSubBtn}`}>Closed</div>
                    </a>
                  </li>
                </ul>
              ) : null}
            </>
          ) : null}
          {currentUser?.data ? (
            <a href='/profile' onClick={() => handleEventTrigger('Open_Profile_Dashboard')}>
              <div className={path === '/profile' ? `${Style.normalBtn} ${Style.selectedBig} border-top-grey-2` : `${Style.normalBtn} border-top-grey-2`}>
                <img src={path === '/profile' ? '/images/header-images/user-octagon-selected.svg' : '/images/header-images/user-octagon.svg'} />
                <div className='relative-position'>
                  <div className='y-center-Pos'>My Profile</div>
                </div>
              </div>
            </a>
          ) : null}
          {currentUser?.data ? (
            <a href='/my-referrals'>
              <div className={path === '/my-referrals' ? `${Style.normalBtn} ${Style.selectedBig}` : `${Style.normalBtn}`}>
                <img src={path === '/my-referrals' ? '/images/header-images/share-selected.svg' : '/images/header-images/share.svg'} />
                <div className='relative-position'>
                  <div className='y-center-Pos'>My Referrals</div>
                </div>
              </div>
            </a>
          ) : null}
          <a href='/faqs' onClick={() => handleEventTrigger('FAQ_Browse_Job')}>
            <div className={path === '/faqs' ? `${Style.normalBtn} ${Style.selectedBig} border-top-grey-2` : `${Style.normalBtn} border-top-grey-2`}>
              <img src={path === '/faqs' ? '/images/header-images/faq-selected.svg' : '/images/header-images/message.svg'} />
              <div className='relative-position'>
                <div className='y-center-Pos'>FAQs</div>
              </div>
            </div>
          </a>
          <a href='/why-awign' onClick={() => handleEventTrigger('Why_AEx_Browse_Job')}>
            <div className={path === '/why-awign' ? `${Style.normalBtn} ${Style.selectedBig}` : `${Style.normalBtn}`}>
              <img src={path === '/why-awign' ? '/images/header-images/why-awign-selected.svg' : '/images/header-images/profile-tick.svg'} />
              <div className='relative-position'>
                <div className='y-center-Pos'>Why Awign Expert?</div>
              </div>
            </div>
          </a>
          {currentUser?.data ? (
            <div className={Style.normalBtn} onClick={handleLogout}>
              <img src='/images/job-dashboard/logout-side.svg' />
              <div className='relative-position'>
                <div className='y-center-Pos'>Logout</div>
              </div>
            </div>
          ) : (
            <div className={`p-t-20 m-l-35 border-top-solid-gray-4 w-75 `}>
              <a href='/vendor'>
                <div className='border-gray-4 flex-style-space-between padding16 br-8 full-width-imp black'>
                  <div>
                    <div className='font-12px fw-600 text-align-left'>Have an existing</div>
                    <div className='font-12px fw-600 text-align-left'>talent pool?</div>
                    <div className='font-10px text-align-left'>
                      Join Vendor Network <img src='/images/homepage/arrow-right.svg' />
                    </div>
                  </div>
                  <img src='/images/homepage/vendor_btn.svg' />
                </div>
              </a>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default MobileSidebar;
